// F1 Teams Page
import React from 'react';
import { useF1Championship } from '../../hooks/useF1Championship';
import F1PageTemplate from '../../components/f1/F1PageTemplate';
import { teamsConfig } from '../../components/f1/TeamsComponent';
import TeamsComponent from '../../components/f1/TeamsComponent';

const F1TeamsPage = () => {
  const { data } = useF1Championship();

  const stats = teamsConfig.stats.map(stat => ({
    ...stat,
    value: typeof stat.value === 'function' ? stat.value(data) : stat.value
  }));

  return (
    <F1PageTemplate
      title={teamsConfig.title}
      subtitle={teamsConfig.subtitle}
      summary={teamsConfig.summary}
      stats={stats}
    >
      <TeamsComponent data={data} />
    </F1PageTemplate>
  );
};

export default F1TeamsPage;
